/** UUID v4 via Web Crypto. `randomUUID` needs a secure context, so fall back to getRandomValues. */
export function uuidv4(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/** Sent as `X-Request-Id` on every call; echoed back in the error envelope as `request_id`. */
export const newRequestId = uuidv4;

/**
 * Sent as `Idempotency-Key` on every write. Generate ONE per logical operation and
 * reuse it on retries of that operation; a fresh key means "do it again".
 */
export const newIdempotencyKey = uuidv4;
